import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SliderModelService } from '../../../services/infrastructure/sliderModel.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-grower-program-budget',
  templateUrl: './grower-program-budget.component.html',
  styleUrls: ['./grower-program-budget.component.scss']
})

export class GrowerProgramBudgetComponent implements OnInit {
  subscription = new Array<Subscription>();
  selectedElement: any;
  selectedRowId: number = 0;
  budgetDataSource: any;
  displayedColumns: string[] = [
    'rowNumber',
    'programName',
    'budgetName',
    'budgetOwner',
  ];

  constructor(private sliderModelService: SliderModelService,
    private loaderService: LoaderService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.sliderModelService.initializegpBudgetSliderValue.subscribe(data => {
      this.budgetDataSource = data;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  selectRow(element) {
      this.selectedElement = element;
      this.selectedRowId = element.id;
  }

  selectBudget() {
    this.sliderModelService.selectedBudgetValue.next(this.selectedElement);
    this.sliderModelService.growerProgramBudgetSlider.next(false);
    this.sliderModelService.close();
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
